import SocialAppContainer from "../../Componant/SocialApp";

const SocialApp = () => {
  return (
    <div className="page-body">
      <SocialAppContainer />
    </div>
  );
};

export default SocialApp;
